import * as angular from "angular";
import {NavigationMenu} from "../../models/navigation-menu/navigation-menu.model";
import {ApiUrl} from "../../models/app-config.model";

interface NavigationResponse { data: NavigationMenu; }

export interface NavigationMenuService {
    (tenantId?: string, district?: boolean): angular.IPromise<NavigationMenu>;
}

/* @ngInject */
export function navigationMenuService(API_URL: ApiUrl, $http: angular.IHttpService) {
    return (tenantId: string, district?: boolean): angular.IPromise<NavigationMenu> => {
        let districtStr = district ? "/district" : "";
        return $http.get(`${API_URL.navigation}${districtStr}/${tenantId}`)
            .then((response: NavigationResponse) => {
            return response.data;
        });
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/top-nav/navigation-menu.service.ts
 **/